export default "__VITE_ASSET__CPpU1JZP__"